export default {
	items: [],
	removedItems: [],
	shipping: 0,
	shippingAddress: null,
	billingAddress: null,
	deliveryInstructions: '',
	deliveryDate: null,
	paymentMethod: null,
	discountCode: '',
	referral: '',
	channel: ''
}
